import * as React from 'react';

import classNames from 'classnames';
import { Link } from 'gatsby';

import ArrowRightTop from '@/icons/arrow-right-top.svg';

import './Label.scss';

interface Item {
  id: string;
  title: string;
  link?: string;
}

interface Props {
  item: Item;
  size?: 'large' | 'medium' | 'small';
  showArrow?: boolean;
}

const Label = ({ item, size = 'medium', showArrow }: Props) => {
  const typographyClassName = size === 'large' ? 'list-1' : 'body-3';

  return (
    <li
      className={classNames(
        'Label_item button-labels',
        { 'large-size': size === 'large' },
        { 'medium-size': size === 'medium' },
        { 'small-size': size === 'small' },
      )}
      key={item.id}
    >
      {item.link ? (
        <Link
          className={`button-func ${typographyClassName} cover-button Label_links`}
          aria-label={item.title}
          to={item.link}
        >
          {item.title}
          {showArrow && <ArrowRightTop />}
        </Link>
      ) : (
        item.title && <p className={classNames(`Label_paragraph ${typographyClassName}`)}>{item.title}</p>
      )}
    </li>
  );
};

export default Label;
